meedy.controller('meedy.messagesViewController', ['$scope', '$state', '$stateParams', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.messagesModel',
    function ($scope, $state, $stateParams, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, messagesModel) {

        function setData() {
            $scope.titleSource = '';
            $scope.contentSource = '';
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.MESSAGES.GET_BY_ID.SUCCESS, function(event, message) {
                $scope.titleSource = message.title;
                $scope.contentSource = message.content;
                $scope.message = message;

                if(!$scope.message.confirmed) {
                    messagesModel.newMessages--;
                }
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {
            $scope.goToPersonalData = function() {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.PERSONAL_DATA, {'patientId' : $scope.message.edmPatientId });
                return false;
            }
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.MESSAGES);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.MESSAGES');
        }

        function initialize() {
            messagesModel.getById($stateParams.id);
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
